export default "__VITE_ASSET__DJqvSqJv__"